export default {
      id: "reefer-battery-usage",
      viewBox: "0 0 33 24",
      url: __webpack_public_path__ + "img/icons.svg#reefer-battery",
      toString: function () {
        return this.url;
      }
    }